export const GET_PERSONALITIES = "GET_PERSONALITIES";
export const GET_PERSONALITIE_BY_ID = "GET_PERSONALITIE_BY_ID";
export const UPDATE_PERSONALITIE = "UPDATE_PERSONALITIE";
export const DELETE_PERSONALITIE = "DELETE_PERSONALITIE";
export const CREATE_PERSONALITIE = "CREATE_PERSONALITIE";
